import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';

@NgModule({
  imports: [
    CommonModule,
    I18NextModule
  ],
  exports: [
    CommonModule,
    I18NextModule
  ]
})
export class SharedModule { }